// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Be2i","controls":"styles_controls__fvhgB","charLimit":"styles_charLimit__3I3PT","input":"styles_input__3viqz","send":"styles_send__1gDZK"};